/* @flow */
/* eslint-env es6,browser */

import * as u from '../utils';
import * as jsonp from '../jsonp';
import bidbase from './bidbase';
import bm from '../bidmanager';

/**
 * @module bidders/breal
 */
/**
 * @global
 * @typedef {object} brealConfig
 * @description extends {@link hbConfig}
 * @property {string} bidUrl
 */
/**
 * @description Implements functionality for breal header bidding
 * @extends _bidbase
 * @requires {@link module:utils}
 * @requires {@link module:jsonp}
 */
class _brealbid extends bidbase {

  /**
   * Create brealbid obj
   * @param {string} name
   */
  constructor(name: string){
    super(name);
    this._mandatoryConfigs = ['bidUrl'];
    this._renderType = 'iframe';
  }

  /**
   * Process bid response. Response Format:
   * _bidResponses[id].cpm - ecpm
   * _bidResponses[id].ad - ad ifrmae url
   * @param {Array<string>} posList - array of positions
   * @param {Object.<string, hbPosData>} ret
   * @return {Object.<string, hbPosData>}
   * @access private
   */
  _processBidResponse(posList: Array<string>, ret: hbPartnerData): hbPartnerData {
    var id = '', res = {};
    posList.forEach(pos => {
      id = this.getPosKey(pos),
      res = this._bidResponses[id];
      if (res && res.cpm && res.ad) {
        this._handleBidPosData(ret, pos, `${res.cpm/10000}`, id, res.ad);
      }
    });
    return ret;
  }

  _getBid(pos: string): Promise<*> {
    // build params for bid request
    let params = {};
    params.data = {
      id: this.getPosKey(pos),
      size: `${this._config.posTokenMap[pos].width}x${this._config.posTokenMap[pos].height}`,
      referrer: document.location.href
    };
    params.logPrefix = pos;
    params.timeout = this._config.timeout;
    return jsonp.JSONP(this._config.bidUrl, params).then(data => {
      if (data && data.result) {
        this._bidResponses[this.getPosKey(pos)] = data.result;
      }
    });
  }

 /**
   * get bids for given positions
   * @param {Array<string>} posList
   * @param {Object.<string, hbPosData>} ret
   * @return {Promise<Object.<string, hbPosData>>}
   * @access private
   */
  _getAds(posList: Array<string>, ret: hbPartnerData): Promise<hbPartnerData> {
    this._bidResponses = {};

    //Create promise array with all bid requests
    let pArray = posList.map(pos => this._getBid(pos));

    //Resolve all accumulated promise here
    return u.allSettledPromise(pArray)
      .then(arr => {
        let fValues = arr.filter(v => v.state !== 'fulfilled').map(v => v.reason);
        if (fValues.length) {  //Log all failed promise
          u.logError(`${this._name} bidding errors: ${fValues.join(',')}`);
        }
        return this._processBidResponse(posList, ret);
      }, error => {
        u.logError(`${this._name} bidding failed: ${error || ''}`);
        return ret;
      });
  }
}

//add bidders to bidmanager
let breal = new _brealbid('breal'),
  appnexus = new _brealbid('appnexus'),
  defy = new _brealbid('defy'),
  districtm = new _brealbid('districtm');
bm.addBidder('breal', breal);
bm.addBidder('appnexus', appnexus);
bm.addBidder('defy', defy);
bm.addBidder('districtm', districtm);
export { breal, appnexus, defy, districtm };
